import {
  GetInitialMessagesResponse,
  SendMessageRequest,
  SendMessageResponse,
} from "@financial-advisory/data-access/api-types";
import { orchestrationApi } from "./orchestrationApi";

export const SHARED_SEND_MESSAGE_CACHE_KEY = "shared-send-message";

const messagesApi = orchestrationApi.injectEndpoints({
  endpoints: (builder) => ({
    sendMessage: builder.mutation<SendMessageResponse, SendMessageRequest>({
      query: (body) => {
        return {
          url: `/messages`,
          method: "POST",
          body,
        };
      },
    }),
    getInitialMessages: builder.query<GetInitialMessagesResponse, void>({
      query: () => ({
        url: `/messages/initial-messages`,
        method: "GET",
      }),
    }),
  }),
});

export const { useSendMessageMutation, useGetInitialMessagesQuery } =
  messagesApi;
